import React, { useEffect, useState } from "react";
import LogoMain from "../../assets/images/logo-main.png";
import customHistory from "../../components/RouteHistory";
import { RouteNames } from "../../constants";
import { FiArrowLeft } from "react-icons/fi";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useParams } from "react-router-dom";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  AcceptPrivacyPolicy,
  GetPrivacyPolicyStatus,
} from "../../redux/selfService/selfServiceSlice";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const PrivacyPage = () => {
  const [accepted, setAccepted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false); // State to track checkbox status
  const { isLoading } = useAppSelector((state) => state?.selfService);
  const { identifier } = useParams(); // Get the unique identifier from the query string
  const dispatch = useAppDispatch();

  const validationSchema = Yup.object().shape({
    acceptPrivacyPolicy: Yup.boolean().oneOf(
      [true],
      "You must accept the Privacy Policy"
    ),

    // Add more validation rules for other fields as needed
  });

  //   const defaultValues = {
  //     acceptPrivacyPolicy: false, // Initial value for the "email" field
  //     // Add default values for other fields as needed
  //   };

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      acceptPrivacyPolicy: accepted, // Initialize the checkbox value based on 'accepted' state
    },
  });

  useEffect(() => {
    // Make an API call to check if the user has already accepted the privacy policy
    // You can use the 'identifier' variable to send the query parameter to your API endpoint.
    // Example API call:
    // fetch(`/api/checkPrivacyPolicyStatus?identifier=${identifier}`)
    //   .then((response) => response.json())
    //   .then((data) => {
    //     setAccepted(data.accepted);
    //   })
    //   .catch((error) => {
    //     console.error('Error checking privacy policy status:', error);
    //   });

    dispatch(GetPrivacyPolicyStatus({})).then((res) => {
      console.log("Response:", res);
      if (
        res?.type === "selfServices/getPrivacy/fulfilled" &&
        res.payload !== undefined
      ) {
        // Reset the form or perform any other action upon acceptance
        // reset(defaultValues);
      }
    });

    // For now, let's set 'accepted' to true for demonstration purposes
    setAccepted(false);
  }, [identifier]);

  // Update the checkboxChecked state when the checkbox changes
  const handleCheckboxChange = (event) => {
    setCheckboxChecked(event.target.checked);
  };

  const acceptPrivacyPolicy = () => {
    // Handle user acceptance logic here
    // You can save the user's acceptance status in your application's state or send it to the server.
    // For now, let's just set it to true.
    //   setAccepted(true);

    if (checkboxChecked) {
      // Make a call to the backend with the privacy policy payload
      const uniqueIdentifier = identifier; // Get this from the query string
      dispatch(
        AcceptPrivacyPolicy({
          status: true,
          uniqueIdentifier: uniqueIdentifier,
        })
      ).then((res) => {
        console.log("Response:", res);
        if (
          res?.type === "SelfServices/privacy/fulfilled" &&
          res.payload !== undefined
        ) {
          // Reset the form or perform any other action upon acceptance
          // reset(defaultValues);
        }
      });
    } else {
      // Show a message to the user that they must check the box to accept the privacy policy
      alert("Please check the box to accept the Privacy Policy.");
    }
  };

  return (
    <TimeOutActivityLayout>
      <div className="pp-page">
        <div className="sidebar-logo">
          <img
            src={LogoMain}
            alt=""
            style={{
              width: "100px",
            }}
          />
        </div>
        <div>
          <div className="flex text-primary mb-4">
            {/* @ts-ignore*/}
            {/* <button className="btn btn-outline font-semibold mr-4" onClick={()=>customHistory.push(RouteNames.DASHBOARD)}>
                        <FiArrowLeft className="mr-1 text-xl"/>
                        Back
                    </button> */}
          </div>
        </div>
        <h2
          className="heading text-center"
          style={{
            color: "#000",
            fontSize: "2.5rem",
            // fontWeight: "bold",
            marginBottom: "20px",
          }}
        >
          Privacy Policy
        </h2>
        <div className="pp">
          <div className="pp-group">
            {/* <div className="pp-group-head">PRIVACY POLICY HIGHLIGHTS</div> */}
            <div className="pp-group-text">
              This privacy policy for <b>NLPC Pension</b> Fund Administrators
              Limited (doing business as NLPC Pension and previously as{" "}
              <b>NLPC PFA</b>), “<b>we</b>”, “<b>us</b>” or “<b>our</b>”
              describes how and why we might access, collect, store, use and/or
              share (“<b>process</b>”) your personal information when you use
              our services (“<b>services</b>”), including when you:
            </div>

            <ul
              style={{
                marginTop: "10px",
              }}
            >
              <li>
                Visit our website at{" "}
                <a
                  href="https://www.nlpcpfa.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.nlpcpfa.com
                </a>
                , or any website of ours that links to this privacy notice.
              </li>
              <li>
                Download and use our mobile application (
                <strong>PenSmart</strong>), or any other application of ours
                that links to this privacy notice.
              </li>
              <li>
                Interact with us through our staff and agents in the matter of
                pension fund management and product offerings such as the
                opening of a retirement savings account (RSA), micro pension
                plan (MPP) and other related services that refer to this privacy
                notice.
              </li>
              <li>
                Engage with us in other related ways, including sales,
                marketing, or events.
              </li>
            </ul>
          </div>
          <div
            className="pp-group"
            id="summary-of-key-points"
            style={{
              padding: "20px 0 0 0",
            }}
          >
            <div className="pp-group-head">SUMMARY OF KEY POINTS</div>
            {/* <div className="pp-group-text">
              In this Privacy Policy, we describe the types of personal
              information we collect through our Services, how we use this
              information, for how long we keep it and with which par es we
              share it. We also explain what choices and rights you have in rela
              on to the use of your information, including a right to object to
              some of the processing we carry out (if provided by applicable
              law). More information about your rights, and how to exercise
              them, is set out in the “<a href="#your-rights">Your Rights</a>”
              section. We also provide our contact details, so that you can
              contact us if you have ques ons about this Privacy Policy and our
              privacy practices.
            </div> */}
            <p>
              This summary provides key points from our Privacy Notice, but you
              can find out more details about any of these topics by clicking
              the link following each key point or by using our table of
              contents below to find the section you are looking for.
            </p>

            <p>
              <strong>What personal information do we process?</strong> When you
              visit, use, or navigate our Services, we may process personal
              information depending on how you interact with us and the
              Services, the choices you make, and the products and features you
              use. Learn more about personal information you disclose to us.
            </p>

            <p>
              <strong>Do we process any sensitive personal information?</strong>{" "}
              Some of the information may be considered 'special' or 'sensitive'
              in certain jurisdictions, for example your racial or ethnic
              origins, sexual orientation, and religious beliefs. We may process
              sensitive personal information when necessary, with your consent
              or as otherwise permitted by applicable law. Learn more about
              sensitive information we process.
            </p>

            <p>
              <strong>Do we collect any information from third parties?</strong>{" "}
              We do not collect any information from third parties.
            </p>

            <p>
              <strong>How do we process your information?</strong> We process
              your information to provide, improve, and administer our Services,
              communicate with you, for security and fraud prevention, and to
              comply with law. We may also process your information for other
              purposes with your consent. We process your information only when
              we have a valid legal reason to do so. Learn more about how we
              process your information.
            </p>

            <p>
              <strong>
                In what situations and with which types of parties do we share
                personal information?
              </strong>
              We may share information in specific situations and with specific
              categories of third parties. Learn more about when and with whom
              we share your personal information.
            </p>

            <p>
              <strong>How do we keep your information safe?</strong> We have
              adequate organisational and technical processes and procedures in
              place to protect your personal information. However, no electronic
              transmission over the internet or information storage technology
              can be guaranteed to be 100% secure, so we cannot promise or
              guarantee that hackers, cybercriminals, or other unauthorised
              third parties will not be able to defeat our security and
              improperly collect, access, steal, or modify your information.
              Learn more about how we keep your information safe.
            </p>

            <p>
              <strong>What are your rights?</strong> Depending on where you are
              located geographically, the applicable privacy law may mean you
              have certain rights regarding your personal information. Learn
              more about your privacy rights.
            </p>

            <p>
              <strong>How do you exercise your rights?</strong> The easiest way
              to exercise your rights is by submitting a data subject access
              request, or by contacting us. We will consider and act upon any
              request in accordance with applicable data protection laws.
            </p>
          </div>

          <div className="table-of-contents">
            <p
              style={{
                marginBottom: "20px",
              }}
            >
              Want to learn more about what we do with any information we
              collect? Review the Privacy Notice in full.
            </p>
            <h2>TABLE OF CONTENTS</h2>
            <ul>
              <li>
                <a href="#summary-of-key-points">SUMMARY OF KEY POINTS</a>
              </li>
              {/* <li>
                <a href="#table-of-contents">TABLE OF CONTENTS</a>
              </li> */}
              <li>
                <a href="#what-information-do-we-collect">
                  1. WHAT INFORMATION DO WE COLLECT?
                </a>
              </li>
              <li>
                <a href="#how-do-we-process-your-information">
                  2. HOW DO WE PROCESS YOUR INFORMATION?
                </a>
              </li>
              <li>
                <a href="#with-whom-do-we-share-your-information">
                  3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                </a>
              </li>
              <li>
                <a href="#use-of-cookies-and-tracking">
                  4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                </a>
              </li>
              <li>
                <a href="#data-retention">
                  5. HOW LONG DO WE KEEP YOUR INFORMATION?
                </a>
              </li>
              <li>
                <a href="#data-security">
                  6. HOW DO WE KEEP YOUR INFORMATION SAFE?
                </a>
              </li>
              <li>
                <a href="#information-from-minors">
                  7. DO WE COLLECT INFORMATION FROM MINORS?
                </a>
              </li>
              <li>
                <a href="#privacy-rights">8. WHAT ARE YOUR PRIVACY RIGHTS?</a>
              </li>
              <li>
                <a href="#do-not-track-controls">
                  9. CONTROLS FOR DO-NOT-TRACK FEATURES
                </a>
              </li>
              <li>
                <a href="#policy-updates">
                  10. DO WE MAKE UPDATES TO THIS NOTICE?
                </a>
              </li>
              <li>
                <a href="#contact-us">
                  11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                </a>
              </li>
              <li>
                <a href="#review-update-delete">
                  12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT
                  FROM YOU?
                </a>
              </li>
            </ul>
          </div>

          <div
            className="pp-group"
            id="what-information-do-we-collect"
            style={{
              padding: "20px 0 0 0",
              marginTop: "50px",
            }}
          >
            <h2>
              {" "}
              <strong>1. WHAT INFORMATION DO WE COLLECT?</strong>
            </h2>

            <h3>Personal information you disclose to us</h3>

            <p>
              <em>In Short:</em> We collect personal information that you
              provide to us.
            </p>

            <p>
              We collect personal information that you voluntarily provide to us
              when you register on the Services, express an interest in
              obtaining information about us or our products and Services, when
              you participate in activities on the Services, or otherwise when
              you contact us.
            </p>

            <p>
              <strong>Personal Information Provided by You:</strong> The
              personal information that we collect depends on the context of
              your interactions with us and the Services, the choices you make,
              and the products and features you use. The personal information we
              collect may include the following:
            </p>

            <ul>
              <li>Names Phone Numbers.</li>
              <li>Email Address.</li>
              <li>Mailing Address.</li>
              <li>Job Title.</li>
              <li>Username.</li>
              <li>Contact Preferences.</li>
              <li>Contact or Authentication Data.</li>
              <li>Bank Account Details.</li>
              <li>Date of Birth (DoB).</li>
              <li>Place of Birth (PoB).</li>
              <li>Next of Kin (NoK).</li>
              <li>Employer.</li>
              <li>Salary/Remuneration Data.</li>
            </ul>
            <br />

            <p>
              <strong>Sensitive Information:</strong> When necessary, with your
              consent or as otherwise permitted by applicable law, we process
              the following categories of sensitive information:
            </p>

            <ul>
              <li>Biometric Data.</li>
              <li>National Identity Number (NIN).</li>
              <li>Information revealing ethnic origin.</li>
              <li>Information revealing Religious or Philosophical beliefs.</li>
              <li>Information revealing Trade Union Membership. </li>
              <li>Financial Data.</li>
              <li>Mortgage Equity Data </li>
            </ul>

            <div
              className="application-data"
              id="information-automatically-collected"
              style={{
                marginTop: "50px",
              }}
            >
              <p>
                <strong>Application Data.</strong> If you use our
                application(s), we also may collect the following information if
                you choose to provide us with access or permission:
              </p>

              <ul>
                <li>
                  <strong>Push Notifications.</strong> We may request to send
                  you push notifications regarding your account or certain
                  features of the application(s). If you wish to opt out from
                  receiving these types of communications, you may turn them off
                  in your device's settings.
                </li>
              </ul>

              <p>
                This information is primarily needed to maintain the security
                and operation of our application(s), for troubleshooting, and
                for our internal analytics and reporting purposes.
              </p>

              <p>
                All personal information that you provide to us must be true,
                complete, and accurate, and you must notify us of any changes to
                such personal information.
              </p>

              <h3>Information automatically collected</h3>

              <p>
                <em>In Short:</em> Some information — such as your Internet
                Protocol (IP) address and/or browser and device characteristics
                — is collected automatically when you visit our Services.
              </p>

              <p>
                We automatically collect certain information when you visit,
                use, or navigate the Services. This information does not reveal
                your specific identity (like your name or contact information)
                but may include device and usage information, such as your IP
                address, browser and device characteristics, operating system,
                language preferences, referring URLs, device name, country,
                location, information about how and when you use our Services,
                and other technical information. This information is primarily
                needed to maintain the security and operation of our Services,
                and for our internal analytics and reporting purposes.
              </p>

              <p>
                Like many businesses, we also collect information through
                cookies and similar technologies. You can find out more about
                this in our{" "}
                {/* <a
                  href="https://www.nlpcpfa.com/privacy/cookie-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                > */}
                Cookie Notice
                {/* </a> */}.
              </p>

              <p>The information we collect includes:</p>

              <ul>
                <li>
                  <strong>Log and Usage Data.</strong> Log and usage data is
                  service-related, diagnostic, usage, and performance
                  information our servers automatically collect when you access
                  or use our Services and which we record in log files.
                  Depending on how you interact with us, this log data may
                  include your IP address, device information, browser type, and
                  settings and information about your activity in the Services
                  (such as the date/time stamps associated with your usage,
                  pages and files viewed, searches, and other actions you take
                  such as which features you use), device event information
                  (such as system activity, error reports (sometimes called
                  'crash dumps'), and hardware settings).
                </li>
                <li>
                  <strong>Device Data.</strong> We collect device data such as
                  information about your computer, phone, tablet, or other
                  device you use to access the Services. Depending on the device
                  used, this device data may include information such as your IP
                  address (or proxy server), device and application
                  identification numbers, location, browser type, hardware
                  model, Internet service provider and/or mobile carrier,
                  operating system, and system configuration information.
                </li>
                <li>
                  <strong>Location Data.</strong> We collect location data such
                  as information about your device's location, which can be
                  either precise or imprecise. How much information we collect
                  depends on the type and settings of the device you use to
                  access the Services. For example, we may use GPS and other
                  technologies to collect geolocation data that tells us your
                  current location (based on your IP address). You can opt out
                  of allowing us to collect this information either by refusing
                  access to the information or by disabling your Location
                  setting on your device. However, if you choose to opt out, you
                  may not be able to use certain aspects of the Services.
                </li>
              </ul>
            </div>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="how-do-we-process-your-information"
          >
            <h2>
              {" "}
              <strong>2. HOW DO WE PROCESS YOUR INFORMATION?</strong>
            </h2>

            <p>
              <em>In Short:</em> We process your information to provide,
              improve, and administer our Services, communicate with you, for
              security and fraud prevention, and to comply with law.
            </p>

            <p>
              We may also process your information for other purposes with your
              consent. We process your personal information for a variety of
              reasons, depending on how you interact with our Services,
              including:
            </p>

            <ul>
              <li>
                <strong>
                  To facilitate account creation and authentication and
                  otherwise manage user accounts.
                </strong>
                We may process your information so you can create and log in to
                your account, as well as keep your account in working order.
              </li>
              <li>
                <strong>
                  To deliver and facilitate delivery of services to the user.
                </strong>{" "}
                We may process your information to provide you with the
                requested service.
              </li>
              <li>
                <strong>
                  To respond to user inquiries/offer support to users.
                </strong>{" "}
                We may process your information to respond to your inquiries and
                solve any potential issues you might have with the requested
                service.
              </li>
              <li>
                <strong>To fulfil and manage your requests.</strong> We may
                process your information to fulfil and manage your requests,
                contribution payments, benefits payments, and transfer-in and
                transfer-out processing made through the Services.
              </li>
              <li>
                <strong>To request feedback.</strong> We may process your
                information when necessary to request feedback and to contact
                you about your use of our Services.
              </li>
              <li>
                <strong>To deliver targeted advertising to you.</strong> We may
                process your information to develop and display personalised
                content and advertising tailored to your interests, location,
                and more. For more information see our{" "}
                {/* <a
                  href="https://www.nlpcpfa.com/privacy/cookie-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                > */}
                Cookie Notice
                {/* </a> */}.
              </li>
              <li>
                <strong>To protect our Services.</strong> We may process your
                information as part of our efforts to keep our Services safe and
                secure, including fraud monitoring and prevention.
              </li>
              <li>
                <strong>
                  To evaluate and improve our Services, products, marketing, and
                  your experience.
                </strong>
                We may process your information when we believe it is necessary
                to identify usage trends, determine the effectiveness of our
                promotional campaigns, and to evaluate and improve our Services,
                products, marketing, and your experience.
              </li>
              <li>
                <strong>To identify usage trends.</strong> We may process
                information about how you use our Services to better understand
                how they are being used so we can improve them.
              </li>
              <li>
                <strong>To comply with our legal obligations.</strong> We may
                process your information to comply with our legal obligations,
                respond to legal requests, and exercise, establish, or defend
                our legal rights.
              </li>
            </ul>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="with-whom-do-we-share-your-information"
          >
            <h2>
              <strong>
                3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
              </strong>
            </h2>

            <p>
              <em>In Short:</em> We may share information in specific situations
              described in this section and/or with the following categories of
              third parties.
            </p>

            <p>
              <strong>
                Vendors, Consultants, and Other Third-Party Service Providers.
              </strong>{" "}
              We may share your data with third-party vendors, service
              providers, contractors, or agents ("third parties") who perform
              services for us or on our behalf and require access to such
              information to do that work. We have contracts in place with our
              third parties, which are designed to help safeguard your personal
              information. This means that they cannot do anything with your
              personal information unless we have instructed them to do it. They
              will also not share your personal information with any
              organisation apart from us. They also commit to protect the data
              they hold on our behalf and to retain it for the period we
              instruct. The categories of third parties we may share personal
              information with are as follows:
            </p>

            <ul>
              <li>Communication & Collaboration Tools.</li>
              <li>Cloud Computing Services.</li>
              <li>Data Storage Service Providers.</li>
              <li>Finance & Accounting Tools.</li>
              <li>Government Entities.</li>
              <li>Order Fulfillment Service Providers.</li>
              <li>Payment Processors.</li>
              <li>Product Engineering & Design Tools.</li>
              <li>Sales & Marketing Tools.</li>
              <li>User Account Registration & Authentication Services.</li>
            </ul>

            <p>
              We also may need to share your personal information in the
              following situations:
            </p>

            <ul>
              <li>
                <strong>Business Transfers.</strong> We may share or transfer
                your information in connection with, or during negotiations of,
                any merger, sale of company assets, financing, or acquisition of
                all or a portion of our business to another company.
              </li>
            </ul>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="use-of-cookies-and-tracking"
          >
            <h2>
              <strong>
                4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
              </strong>
            </h2>

            <p>
              <em>In Short:</em> We may use cookies and other tracking
              technologies to collect and store your information.
            </p>

            <p>
              We may use cookies and similar tracking technologies (like web
              beacons and pixels) to gather information when you interact with
              our Services. Some online tracking technologies help us maintain
              the security of our Services and your account, prevent crashes,
              fix bugs, save your preferences, and assist with basic site
              functions.
            </p>

            <p>
              We also permit third parties and service providers to use online
              tracking technologies on our Services for analytics and
              advertising, including to help manage and display advertisements,
              to tailor advertisements to your interests, or to send abandoned
              shopping cart reminders (depending on your communication
              preferences). The third parties and service providers use their
              technology to provide advertising about products and services
              tailored to your interests which may appear either on our Services
              or on other websites.
            </p>

            <p>
              Specific information about how we use such technologies and how
              you can refuse certain cookies is set out in our{" "}
              {/* <a
                href="https://www.nlpcpfa.com/privacy/cookie-policy"
                target="_blank"
                rel="noopener noreferrer"
              > */}
              Cookie Notice
              {/* </a> */}.
            </p>

            <h3>Google Analytics</h3>

            <p>
              We may share your information with Google Analytics to track and
              analyse the use of the Services. To opt out of being tracked by
              Google Analytics across the Services, visit{" "}
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://tools.google.com/dlpage/gaoptout
              </a>
              . For more information on the privacy practices of Google, please
              visit the Google Privacy & Terms page.
            </p>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="data-retention"
          >
            <h2>
              <strong>5. HOW LONG DO WE KEEP YOUR INFORMATION?</strong>
            </h2>
            <p>
              <em>In Short:</em> We keep your information for as long as
              necessary to fulfill the purposes outlined in this Privacy Notice
              unless otherwise required by law.
            </p>
            <p>
              We will only keep your personal information for as long as it is
              necessary for the purposes set out in this Privacy Notice, unless
              a longer retention period is required or permitted by law (such as
              tax, accounting, or other legal requirements). No purpose in this
              notice will require us keeping your personal information for
              longer than twelve (12) months past the termination of the user's
              account.
            </p>
            <p>
              When we have no ongoing legitimate business need to process your
              personal information, we will either delete or{" "}
              <strong>anonymise</strong> such information, or, if this is not
              possible (for example, because your personal information has been
              stored in backup archives), then we will securely store your
              personal information and isolate it from any further processing
              until deletion is possible.
            </p>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="data-security"
          >
            <h2>
              <strong>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</strong>
            </h2>
            <p>
              <em>In Short:</em> We aim to protect your personal information
              through a system of <strong>organisational</strong> and technical
              security measures.
            </p>
            <p>
              We have implemented appropriate and reasonable technical and{" "}
              <strong>organisational</strong> security measures designed to
              protect the security of any personal information we process.
              However, despite our safeguards and efforts to secure your
              information, no electronic transmission over the Internet or
              information storage technology can be guaranteed to be 100%
              secure, so we cannot promise or guarantee that hackers,
              cybercriminals, or other <strong>unauthorised</strong> third
              parties will not be able to defeat our security and improperly
              collect, access, steal, or modify your information. Although we
              will do our best to protect your personal information,
              transmission of personal information to and from our Services is
              at your own risk. You should only access the Services within a
              secure environment.
            </p>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="information-from-minors"
          >
            <h2>
              <strong>7. DO WE COLLECT INFORMATION FROM MINORS?</strong>
            </h2>
            <p>
              <em>In Short:</em> We do not knowingly collect data from or market
              to children under 18 years of age.
            </p>
            <p>
              We do not knowingly collect, solicit data from, or market to
              children under 18 years of age, nor do we knowingly sell such
              personal information. By using the Services, you represent that
              you are at least 18 or that you are the parent or guardian of such
              a minor and consent to such minor dependent’s use of the Services.
              If we learn that personal information from users less than 18
              years of age has been collected we will deactivate the account and
              take reasonable measures to promptly delete such data from our
              records. If you become aware of any data that we may have
              collected from children under age 18, please contact us at{" "}
              <a href="mailto:privacy@nlpcpfa.com">privacy@nlpcpfa.com</a>.
            </p>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="privacy-rights"
          >
            <h2>
              <strong>8. WHAT ARE YOUR PRIVACY RIGHTS?</strong>
            </h2>
            <p>
              <em>In Short:</em> You may review, change, or terminate your
              account at any time, depending on your country, province, or state
              of residence.
            </p>

            <p>
              <strong>Withdrawing your consent:</strong> If we are relying on
              your consent to process your personal information, which may be
              express and/or implied consent depending on the applicable law,
              you have the right to withdraw your consent at any time. You can
              withdraw your consent at any time by contacting us by using the
              contact details provided in the section "HOW CAN YOU CONTACT US
              ABOUT THIS NOTICE?" below.
            </p>

            <p>
              However, please note that this will not affect the lawfulness of
              the processing before its withdrawal nor, when applicable law
              allows, will it affect the processing of your personal information
              conducted in reliance on lawful processing grounds other than
              consent.
            </p>

            <h3>Account Information</h3>

            <p>
              If you would at any time like to review or change the information
              in your account or terminate your account, you can:
            </p>

            <ul>
              <li>Contact us using the contact information provided.</li>
              <li>
                <a href="mailto:privacy@nlpcpfa.com">privacy@nlpcpfa.com</a>
              </li>
            </ul>

            <p>
              Upon your request to terminate your account, we will deactivate or
              delete your account and information from our active databases.
              However, we may retain some information in our files to prevent
              fraud, troubleshoot problems, assist with any investigations,
              enforce our legal terms and/or comply with applicable legal
              requirements.
            </p>

            <p>
              <strong>Cookies and similar technologies:</strong> Most Web
              browsers are set to accept cookies by default. If you prefer, you
              can usually choose to set your browser to remove cookies or to
              reject cookies. If you choose to remove cookies or reject cookies,
              this could affect certain features or services of our Services.
              For further information, please see our Cookie Notice
              {/* :{" "} */}
              {/* <a
                href="https://www.nlpcpfa.com/privacy/cookie-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.nlpcpfa.com/privacy/cookie-policy
              </a> */}
              .
            </p>
            <p>
              If you have questions or comments about your privacy rights, you
              may email us at privacy@nlpcpfa.com.{" "}
            </p>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="do-not-track-controls"
          >
            <h2>
              <strong>9. CONTROLS FOR DO-NOT-TRACK FEATURES</strong>
            </h2>
            <p>
              Most web browsers and some mobile operating systems and mobile
              applications include a Do-Not-Track (‘DNT’) feature or setting you
              can activate to signal your privacy preference not to have data
              about your online browsing activities monitored and collected. At
              this stage, no uniform technology standard for{" "}
              <strong>recognising</strong> and implementing DNT signals has been{" "}
              <strong>finalised</strong>. As such, we do not currently respond
              to DNT browser signals or any other mechanism that automatically
              communicates your choice not to be tracked online. If a standard
              for online tracking is adopted that we must follow in the future,
              we will inform you about that practice in a revised version of
              this Privacy Notice.
            </p>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="nigeria-privacy-rights"
          >
            <h2>
              <strong>10. NIGERIA PRIVACY RIGHTS?</strong>
            </h2>
            <p>
              <em>In Short:</em> You may refer to rights based on the country
              you reside in.
            </p>

            <h3>Federal Republic of Nigeria</h3>
            <p>
              At any time, you have the right to request access to or correction
              of your personal information. You can make such a request by
              contacting us by using the contact details provided in the section
              "HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
              YOU?"
            </p>

            <p>
              If you are unsatisfied with the manner in which we address any
              complaint with regard to our processing of personal information,
              you can contact the office of the regulator, the details of which
              are:
            </p>

            <ul>
              <li>The Nigeria Data Protection Commission (NDPC)</li>
              <li>
                General enquiries:{" "}
                <a href="mailto:info@ndpc.gov.ng">info@ndpc.gov.ng</a>
              </li>
            </ul>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="policy-updates"
          >
            <h2>
              <strong>11. DO WE MAKE UPDATES TO THIS NOTICE?</strong>
            </h2>
            <p>
              <em>In Short:</em> Yes, we will update this notice as necessary to
              stay compliant with relevant laws.
            </p>
            <p>
              We may update this Privacy Notice from time to time. The updated
              version will be indicated by an updated "Revised" date at the top
              of this Privacy Notice. If we make material changes to this
              Privacy Notice, we may notify you either by prominently posting a
              notice of such changes or by directly sending you a notification.
              We encourage you to review this Privacy Notice frequently to be
              informed of how we are protecting your information.
            </p>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="contact-us"
          >
            <h2>
              <strong>12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</strong>
            </h2>
            <p>
              If you have questions or comments about this notice, you may
              contact our Data Protection Officer (DPO) by email at{" "}
              <a href="mailto:privacy@nlpcpfa.com">privacy@nlpcpfa.com</a>, by
              phone at (234) 807 430 9321, or contact us by post at:
            </p>

            <address>
              NLPC Pension Fund Administrators Limited
              <br />
              Data Protection Officer
              <br />
              312 Ikorodu Road, Anthony Village
              <br />
              Lagos, Lagos State
              <br />
              Nigeria
            </address>
          </div>

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
            id="review-update-delete"
          >
            <h2>
              <strong>
                13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT
                FROM YOU?
              </strong>
            </h2>
            <p>
              Based on the applicable laws of your country, you may have the
              right to request access to the personal information we collect
              from you, details about how we have processed it, correct
              inaccuracies, or delete your personal information. You may also
              have the right to withdraw your consent to our processing of your
              personal information. These rights may be limited in some
              circumstances by applicable law. To request to review, update, or
              delete your personal information, please fill out and submit a
              data subject access request.
            </p>
          </div>

          {/* <div className="">Last Updated: 15 / Aug / 2023</div>
          <div className="pp-group">
            <div className="pp-group-head">PRIVACY POLICY</div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                1. Who is responsible for your Personal Information?
              </div>
              <p>
                We are responsible for opera ng our website, and for the
                information about you collected through the website.
              </p>
              <p>
                Our contact details can be found in the ‘
                <a href="#contact-us">Contact Us</a>’ section below.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                2. Personal Information We Collect
              </div>
              <p>
                The following types of personal information are collected in
                connection with our Services:
              </p>
              <p>
                <span className="underline">
                  Information You Provide Directly to us or third parties.
                </span>{" "}
                <br />
                When we seek your consent, we will explain at the me of
                obtaining consent from you what information we will be
                collecting and how we will use it.
              </p>
              <p>
                {" "}
                Use of some Services enable us to collect information directly
                from you. Such as:
                <ul>
                  <li>
                    When you register with us or use our Services, you will
                    provide us with information, such as your name, address,
                    date of birth, PIN (PEN) and next of kin, contact
                    information i.e., telephone numbers and email, details of
                    contributions, en bloc, lump sum, and drawdowns, physical or
                    mental health conditions, tribal/ethnic origin, religious or
                    other beliefs of a similar nature, employment details and
                    ﬁnancial details.
                  </li>
                  <li>
                    When you communicate with our customer service units or
                    other staﬀ, we will process these communications (which may
                    include telephone conversations on any of our contact number
                    lines) and other information required to respond to your
                    queries and sa sfy your requests.
                  </li>
                  <li>
                    When you communicate with a third-party application, we will
                    get access to information, such as, your name and email
                    address and social media tags.
                  </li>
                </ul>
              </p>
              <p>
                <span className="underline">
                  Information about Your Use of Our Services
                </span>{" "}
                <br />
                Some mes we receive information about you from third par es
                including from other companies such as Meta, Google, Amazon or
                Twi er. For example, we may receive your information from third
                party social networking providers if you choose to connect to us
                using your social network account.
                <ul>
                  <li>
                    We verify certain information you provide with third par es,
                    such as family, friends, employers or legal practitioners,
                    websites and social media pages made public by you,
                    regulatory agencies, government agencies, for example
                    identity veriﬁcation through the Nigerian Identity
                    Management Commission (NIMC), or credit agencies in order to
                    protect against fraud.
                  </li>
                  <li>
                    We operate Closed Circuit TV Cameras (CCTV) within our
                    premises. Within and around our premises we may collect
                    other information about you captured in video footage.
                  </li>
                  <li>
                    Other information may also be collected when you interact
                    with us via telephone conversations when you call our
                    contact numbers.
                  </li>
                </ul>
              </p>
              <p>
                <span className="underline">
                  Links to Other Websites, Devices, Apps and Features
                </span>
                <br />
                To the extent any linked website, device, app or other feature
                is not owned or controlled by us, we are not responsible for its
                content, use or privacy practices. Our Services may enable you
                to connect to other websites, devices, apps and other features,
                which may operate independently from us and have their own
                privacy no ces or policies. We strongly suggest you review
                before use.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                3. How We Use this Information
              </div>
              <p>
                We keep track of your RSA and the services you receive as a
                client. This ensures that you receive the best possible service
                from us and that all of your information is accessible if you
                switch PFAs. We gather contact information so that we can get in
                touch with you and keep you up to date on our services and
                goods.
              </p>
              <p>
                We also hold records about our employees for employment, pay,
                discipline, pensions, work management, and other HR-related
                issues. This is to guarantee that employment at the NLPC PFA is
                well-managed, and that employees are given the information and
                training they need to do their jobs.
              </p>
              <p>
                Provision of services based on your contractual relationship
                with us. <br />
                We process your personal information when this is necessary
                under our contract with you, including to:
                <ul>
                  <li>
                    Provide you with our services, and speciﬁc features you
                    select when using our services, which may require
                    personalising the content of our Services.
                  </li>
                  <li>
                    Process contributions and payments and deliver to you our
                    products or products of third par es that you obtain through
                    our services and allow you to exercise your rights under the
                    Pension Reform Act (As Amended) 2014.
                  </li>
                  <li>
                    Identify and authenticate you so you may make use of certain
                    of our services. Register and facilitate regulatory
                    processes, resolve technical issues, provide you with
                    customer service support and send you necessary information
                    rela ng to our services.
                  </li>
                </ul>
              </p>
              <p>
                <span className="underline">
                  Legitimate interests of NLPC PFA and/or third par es
                </span>{" "}
                <br />
                We process personal information to the extent this is necessary
                to fulﬁl our legitimate interests (or those of third par es),
                which include our interests to:
                <ul>
                  <li>
                    Eﬀectively manage our relationship with you, including by
                    communicating with you and responding to your queries.
                  </li>
                  <li>
                    Carry out direct marketing activities (beyond legal
                    requirements to obtain your consent), which includes sending
                    you marketing communications via email, telephony, postal
                    mail, SMS, social media channels, or via mobile app push no
                    ﬁca ons, presenting you with online ads both on our services
                    and on third party websites.
                  </li>
                  <li>
                    Defend our company's opera ons against fraud, identity the ,
                    and other illegal or in viola on of our Terms of Use ac ons.
                  </li>
                  <li>
                    Employ authentication mechanisms and other security
                    measures, keep track of security threats, maintain backups,
                    anonymize data, and perform system maintenance services, we
                    may safeguard the security, accessibility, and integrity of
                    our services and information systems.
                  </li>
                  <li>
                    Protect our legal rights as well as the security of end
                    users by resolving complaints, seeking legal counsel,
                    creating, exercising, or defending legal claims rela ng to
                    us or other businesses in our Services.
                  </li>
                  <li>Improve your user experience.</li>
                  <li>
                    Improve our services and customer care, by asking for your
                    comments, conducting surveys and market research, performing
                    data analytics on how our services are used, studying
                    customer behaviours, and developing consumer usage patterns.
                  </li>
                </ul>
                Eﬀectively manage our company's opera ons, which includes
                creating reports, reviewing the success of our services (using
                aggregated data), inspecting our operational procedures, and
                using statistics to guide business decisions.
              </p>
              <p>
                <span className="underline">Your consent</span> <br />
                Where we believe it is acceptable or where it is required by
                law, we will ask for your permission before processing your
                personal information. Consent is used for:
                <ul>
                  <li>
                    Place cookies and use similar technologies in accordance
                    with our Cookie Policies and the information supplied to you
                    when those technologies are used. See the Cookie Policy for
                    the service you are using for more details.
                  </li>
                  <li>
                    Send you marketing communications (where legal requirements
                    call for it or when we want to depend on consent otherwise).
                  </li>
                  <li>
                    Where required by law, consent to analyse information rela
                    ng to your use of the Services combined with various
                    information that you provide to us by other means, for the
                    purposes consistent with this Privacy Policy, in order to
                    provide you with recommendations and customised
                    advertisements of content, products, and services that we or
                    others think you would like, or to allow you to provide you
                    with such information. This may involve delivering marketing
                    via various channels including through, email, through the
                    RSA holders account, on our websites or on third party
                    platforms (including social networks).
                  </li>
                </ul>
                When we depend on your consent, you always have the op on to
                revoke your consent. This will not have an impact on the
                legality of any processing we did prior to receiving your
                withdrawal of permission. Please refer to the "
                <a href="#your-rights">Your Rights</a>" section below if you
                wish to exercise this right.
              </p>
              <p>
                <span className="underline">Legal obligations</span>
                <br />
                Insofar as it is required, we process personal data to:
                <ul>
                  <li>
                    Abide by all applicable legal requirements, such as pension,
                    tax, and accounting obligations.
                  </li>
                  <li>
                    Respond to legally binding requests from the regulator,
                    government, law enforcement, and/or public authorities, as
                    well as court orders.
                  </li>
                </ul>
                You are required to provide this information to us, where we
                need it to perform our contract with you or to comply with our
                legal obligations. You are not obligated to disclose personal
                information in other circumstances, but failing to do so could
                aﬀect how you use our Services.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">4. Sharing Information</div>
              <p>
                We share personal information about you by transferring,
                disclosing, or otherwise making it available as follows:
                <ul>
                  <li>
                    <span className="underline">NLPC PFA personnel</span>: When
                    it's necessary or reasonable to do so for the purposes
                    outlined in section 3 above or in the privacy rules
                    pertaining to our other services, we disclose personal
                    information to our employees, contractors, and
                  </li>
                  <li>
                    <span className="underline">Service Providers</span>: Your
                    information may be transferred or disclosed to carefully ve
                    ed businesses and individuals who perform services for us,
                    such as those who assist us in creating and managing the
                    systems that support our Services, those who provide IT
                    support, hos ng, website upkeep, data maintenance and
                    analytics, customer service and communication, onboarding
                    processing and registration, mailing, billing, marketing and
                    market research services, and other clerical services. These
                    organisations are bound by contractual requirements that,
                    among other things, forbid them from using your information
                    for purposes other than those for which they were hired.
                    They are only permitted to access and use your personal
                    information to the degree necessary for them to perform the
                    services they have been hired to perform for us.
                  </li>
                  <li>
                    <span className="underline">Other business partners</span>:
                    Where it is essen al for you to access the Services you have
                    requested through our Services or marketing materials rela
                    ng to our Services, we may release your personal information
                    to other pension fund operators or business partners.
                  </li>
                  <li>
                    <span className="underline">Business advisors</span>: To the
                    degree that their services are required to be rendered to
                    us, for instance, our lawyers, accountants, business
                    consultants, insurers, and auditors.
                  </li>
                  <li>
                    <span className="underline">
                      Government authorities, judicial authorities, regulators
                      or other third par es where required
                    </span>
                    : When required by law or when we deem it necessary, we may
                    disclose personal information to governmental agencies,
                    judicial authorities, regulators, or other third par es:
                    <ul>
                      <li>
                        to abide by the law or respond to court orders, or other
                        legal proceedings that are mandatory;
                      </li>
                      <li>
                        if permitted by applicable data protection laws, to
                        verify or enforce compliance with the regula ons
                        governing our Services, as well as to look into and stop
                        fraud or other illegal activity related to the use of
                        our Services or harming our business;
                      </li>
                      <li>
                        to safeguard and defend our interests, as well as those
                        of our employees, partners in business, clients, or the
                        public, as well as our property rights.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Corporate Transactions: As part of a merger or transfer,
                    reorganisation, acquisition or sale (including during
                    negotiations), dissolution or other corporate transaction,
                    or in the event of bankruptcy, we may disclose your
                    information to a third party (and their business advisors).
                  </li>
                  <li>
                    Others who have your consent or who you have engaged on your
                    behalf: When you individually consent to or request such
                    sharing, in addi on to the disclosures outlined in this
                    privacy statement, we may disclose information about you
                    with third par es.
                  </li>
                  <li>
                    Google Analytics: We might use third-party analytics
                    services like Google Analytics to gather personal data about
                    your online activities across diﬀerent third-party websites,
                    devices, apps, and other online features and services, as
                    well as over me and across connected devices. These
                    providers and other pertinent third par es use the
                    information, for example, to assess how well the Services
                    are used.
                  </li>
                </ul>
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                5. Retention of Personal Information
              </div>
              <p>
                We take the necessary measures to guarantee that we process and
                store information in accordance with the subsequent guidelines:
                <ul>
                  <li>
                    at a minimum for as long as the data is required to provide
                    you with our services;
                  </li>
                  <li>
                    in compliance with our regulatory opera ons for pension fund
                    administration;
                  </li>
                  <li>
                    in accordance with a contract, the law, or our statutory du
                    es (such as tax legislation); or
                  </li>
                  <li>
                    Only for the duration of period required to fulﬁl the
                    intentions for which it was collected, processed, or longer
                    if obligated by a contract, relevant legislation, or, in
                    anonymized form, for sta s cal use, subject to the necessary
                    precautions. For instance, if there is a disagreement
                    between you and us or if your employer does not make
                    contributions to your RSA, we may keep the pertinent
                    information on ﬁle until the disagreement is se led or the
                    payment is made, as appropriate.
                  </li>
                  <li>
                    When we collect and analyse your information for marketing
                    reasons or with your consent, we do so until you ask us to
                    stop, and then only for a brief period of me (to allow us to
                    carry out your requests). We also retain a record of your
                    request not to receive direct marketing or to process your
                    data forever so that we can honour it in the future.
                  </li>
                </ul>
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">6. Your Choices</div>
              <p>
                We may contact you via email, phone call, text messages, or push
                no ﬁca ons via our mobile apps whenever authorised. Please
                contact us using the details provided in the "
                <a href="#contact-us">Contact Us</a>" section below to make a
                request regarding the receipt of such communications from us.
              </p>
              <p>
                Click the "unsubscribe" link at the bo om of emails or by
                contacting us directly if you wish to be excluded from our
                marketing messages at any me (see the section "
                <a href="#contact-us">Contact Us</a>" below).
              </p>
              <p>
                Please note that if you unsubscribe from our marketing
                communications, we will con nue to send you account related
                messages to provide you with necessary information in rela on to
                your RSA.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head" id="your-rights">
                7. Your Rights
              </div>
              <p>
                To the extent permitted by applicable law, you may request a
                copy of the personal information we have on ﬁle for you. You can
                also request that we delete or correct any inaccuracies in your
                personal information, restrict or limit the processing of your
                personal information, withdraw your consent, and provide you
                with personal information that you provided to us for a contract
                or with your consent in a structured, machine-readable format,
                as well as request that we share (port) this data to another
                controller.
              </p>
              <p>
                Furthermore, to the extent permitted by applicable law, you have
                the right to object to the processing of your personal data in
                some instances (particularly if we are not required to treat the
                data to meet a regulatory, contractual, or other legal duty).
              </p>
              <p>
                Conversely, these rights may be limited, for example, if
                fulﬁlling your request would reveal personal data about another
                person, infringe on the rights of a third party (including our
                rights), or if you ask us to delete information that we are
                required by law to keep or have compelling legitimate interests
                in keeping. Exemptions exist in both the NDPR and national
                legislation.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                8. How We Protect Personal Information
              </div>
              <p>
                We take the security of your information to heart, and we
                implement procedures to protect the information we collect
                through our Services. Please bear in mind that, while we take
                adequate measures to safeguard your information, no website,
                Internet transmission, computer system, or wireless connection
                is en rely risk-free.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                9. International Transfer of Information
              </div>
              <p>
                Your use of our Services will not involve the transfer, storage,
                and processing of your personal information outside of the
                Federal Republic of Nigeria, consistent with this Privacy
                Policy.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                10. Updates to Our Privacy Policy
              </div>
              <p>
                This Privacy Policy may be modiﬁed so that it reﬂects changes in
                our identiﬁable data practises in rela on to our Services, as
                well as changes in relevant law
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head" id="contact-us">
                11. Contact Us
              </div>
              <p>
                Please contact us if you want to exercise your rights or learn
                more about how we u lise your personal information. <br />
                For requests and enquiries rela ng to information about you
                collected via all our Services, please contact: <br />
                Data Protection Oﬃcer: <br />
                Email: dpo@nlpcpfa.com, or via <br />
                Post: 312 Ikorodu Road, Anthony Village, Lagos, Nigeria.
              </p>
            </div>
            <div className="pp-group-text">
              <div className="pp-group-text-head">
                12. Personal Information of Children
              </div>
              <p>
                Our services are aimed at adults working in the formal and
                informal sectors within the Federal Republic of Nigeria, and not
                at children. We do not intentionally collect or keep personal
                information from anyone under the age of 18, unless named as
                beneﬁciaries under an RSA in connection with our Services, nor
                do we knowingly allow such persons to use our Services.
              </p>
              <p>
                Please do not attempt to register for our Services or provide us
                with any personal information if you are under the age of 18. If
                we discover that a person under the age of 18 has provided us
                with personal information, we will delete it as soon as
                possible. If you are aware that a child under the age of 18 has
                provided us with personal information, please no fy us using the
                details listed above in the "
                <a href="#contact-us">Contact Us</a>" section.
              </p>
            </div>
          </div> */}

          <div
            className="pp-group"
            style={{
              padding: "20px 0 0 0",
              marginTop: "-50px",
            }}
          >
            <input
              type="checkbox"
              id="acceptPrivacyPolicy"
              {...register("acceptPrivacyPolicy")}
              checked={checkboxChecked}
              onChange={handleCheckboxChange}
            />
            <label
              htmlFor="acceptPrivacyPolicy"
              style={{
                marginLeft: "10px",
              }}
            >
              I have read and agree to the Privacy Policy
            </label>
            <button
              className={`btn btn-primary font-semibold mr-4 ${
                !checkboxChecked ? "disabled" : ""
              }`}
              onClick={handleSubmit(acceptPrivacyPolicy)}
              disabled={!checkboxChecked}
              // onClick={acceptPrivacyPolicy}
            >
              {isLoading ? <LoadingSpinner /> : "Accept"}
            </button>

            {/* <button
                                className="btn btn-primary font-semibold mr-4"
                                onClick={handleSubmit(onSubmit)}
                                disabled={isLoading}
                            >
                                {
                                    isLoading ? <LoadingSpinner /> : "Accept"
                                }
                            </button> */}
          </div>
        </div>
      </div>
    </TimeOutActivityLayout>
  );
};

export default PrivacyPage;
